import React from "react"
import SideBar from "../common/layout/sidebar.component.jsx"
import ProductTabs from "../common/layout/tabs/products.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing/index"

const Structures = () => {
    SideBar.activateMenu("product")

    return (
        <>
            <ProductTabs />
            <GenericListing
                objectType={ObjectType.MATRICES}
            />
        </>
    )
}

export default Structures


// WEBPACK FOOTER //
// ./src/product/Structures.tsx